import React from 'react';
import { object, func, bool } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import GigCardCarouselWrapper from '../shared/GigCardCarouselWrapper';
import SafePureComponent from '../shared/SafePureComponent';
import { RECOMMENDED_FOR_YOU, CAROUSEL_CONTEXT } from '../../utils/carousels';

import './style.scss';

const SIMILAR_GIGS_SOURCE = 'similar_gigs';

const SimilarGigs = ({
    collections,
    updateCollections,
    isTouch,
    isLoggedIn,
    onEmptyGigs,
    shouldFetchCarousel = true
}, {
    general,
    pathfinderWrapper,
    requestContext
}) => {
    const { gigId } = general;
    const { ref } = requestContext.params;

    const url = pathfinderWrapper.pathfinder(
        'gig_page_fetch_recommendations_by_type',
        { type: 'by_content' },
        { query: { gig_id: gigId, ref } }
    );

    return (
        <GigCardCarouselWrapper boxTitle={<I18n k="gig_page_perseus.recommended_gigs.recommended_for_you.title"/>}
            boxClass="gigs-recommended-for-you"
            boxLocation="main"
            type={RECOMMENDED_FOR_YOU}
            url={url}
            onEmptyGigs={onEmptyGigs}
            carouselPosition={1}
            collections={collections}
            isLoggedIn={isLoggedIn}
            isTouch={isTouch}
            updateCollections={updateCollections}
            source={SIMILAR_GIGS_SOURCE}
            carouselContext={CAROUSEL_CONTEXT}
            shouldFetchCarousel={shouldFetchCarousel}/>
    );
};

SimilarGigs.propTypes = {
    collections: object,
    updateCollections: func,
    isTouch: bool,
    isLoggedIn: bool,
    onEmptyGigs: func,
    shouldFetchCarousel: bool
};

SimilarGigs.contextTypes = {
    general: object,
    pathfinderWrapper: object,
    requestContext: object
};

export { SimilarGigs };
export default SafePureComponent(SimilarGigs);
